/* Product image presentation only. Commerce, prices and room-plan arithmetic are owned by the existing scripts. */
(() => {
  'use strict';
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-gallery-item]')];
    const thumbs = gallery.querySelector('[data-gallery-thumbnails]');
    const enlarge = gallery.querySelector('[data-gallery-enlarge]');
    if (!slides.length || !thumbs) return;
    slides.forEach((slide, index) => {
      if (!slide.dataset.mediaId) slide.dataset.mediaId = `fallback-${index + 1}`;
      const photo = slide.querySelector('img');
      const button = document.createElement('button');
      button.type = 'button';button.className = 'gallery-thumb';
      button.setAttribute('aria-label', `View product image ${index + 1}`);
      if (photo) {
        const preview = document.createElement('img');
        preview.src = photo.currentSrc || photo.src;
        preview.alt = '';preview.width = 68;preview.height = 68;preview.loading = 'lazy';
        button.append(preview);
      } else button.textContent = String(index + 1);
      button.addEventListener('click', () => gallery.dispatchEvent(new CustomEvent('highabode:select-media', {detail: {id: slide.dataset.mediaId}})));
      thumbs.append(button);
    });
    const synchronize = () => {
      const index = slides.findIndex(slide => !slide.hidden);
      [...thumbs.children].forEach((button, current) => {
        button.setAttribute('aria-pressed', String(current === index));
        if (current === index) button.setAttribute('aria-current', 'true');else button.removeAttribute('aria-current');
      });
      if (enlarge) enlarge.hidden = !slides[index]?.querySelector('img');
    };
    const observer = new MutationObserver(synchronize);
    slides.forEach(slide => observer.observe(slide, {attributes: true, attributeFilter: ['hidden']}));
    synchronize();
    if (!enlarge) return;
    const dialog = document.createElement('dialog');dialog.className = 'gallery-lightbox';
    dialog.setAttribute('aria-label', 'Enlarged product image');
    const close = document.createElement('button');close.type = 'button';close.className = 'lightbox-close';close.textContent = 'Close ×';
    const image = document.createElement('img');
    const caption = document.createElement('p');caption.className = 'lightbox-caption';
    dialog.append(close, image, caption);document.body.append(dialog);
    const shut = () => {dialog.close();};
    close.addEventListener('click', shut);
    dialog.addEventListener('click', event => {if (event.target === dialog) shut();});
    dialog.addEventListener('close', () => {document.body.classList.remove('gallery-dialog-open');enlarge.focus();});
    const open = () => {
      const photo = slides.find(slide => !slide.hidden)?.querySelector('img');
      if (!photo || typeof dialog.showModal !== 'function') return;
      image.src = photo.currentSrc || photo.src;image.alt = photo.alt;
      caption.textContent = photo.alt;
      dialog.showModal();document.body.classList.add('gallery-dialog-open');close.focus();
    };
    enlarge.addEventListener('click', open);
    slides.forEach(slide => {const photo = slide.querySelector('img');if (photo) photo.addEventListener('click', open);});
  });
})();
